// extracted by mini-css-extract-plugin
module.exports = {"refundsList":"SourceRefundsList_refundsList__18q_I"};